import remove from '../../lib/dom/element-remove';
import children from '../../lib/dom/element-children';
import { hasClass } from '../../lib/dom/className';



export const disable = () => {
  children(document.body)
    .filter((element) => hasClass(element, 'smprldr'))
    .forEach((element) => remove(element));
};



// WEBPACK FOOTER //
// ./src/lib/preloader/preloader.js